import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {SharedService} from '../shared.service';
import {c} from '@angular/core/src/render3';

@Component({
  selector: 'app-account-pin-validator',
  templateUrl: './account-pin-validator.component.html',
  styleUrls: ['./account-pin-validator.component.css']
})
export class AccountPinValidatorComponent implements OnInit {
  @Input('accountPin') accountPin: string;
  @Input('accountIdentifier') accountIdentifier: string;
  @Input('overrideLabel') overrideLabel: string | undefined = undefined
  @Output() onPinResponse: EventEmitter<any> = new EventEmitter<any>();
  public pin_text = 'Submit';
  PIN_REGEX = /^\d{4}$/;
  enteredPin = '';
  validPin = false;
  isValidatingPin = false;
  isValidPin = false;
  callCenterFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(this.PIN_REGEX)]);
  constructor(
    private sharedService: SharedService
  ) {
  }

  ngOnInit() {
    if (this.callCenterFormControl.disabled) {
      this.callCenterFormControl.enable();
    }
  }
  onPinResponseCallback(success: boolean, token: string) {
    this.onPinResponse.emit({success, token});
  }
  validateAccountPin(event: any) {
    if (this.enteredPin && this.enteredPin.match(this.PIN_REGEX)) {
      this.validPin = true;
      if (event.keyCode === 13) {
        document.getElementById('btn-click').click();
      }
    }
  }
  checkPin() {
    this.callCenterFormControl.disable();
    this.isValidatingPin = true;
    this.pin_text = 'Validating...';
    this.callCenterFormControl.setErrors({invalid: false})
    this.callCenterFormControl.setErrors({exception: false})
    this.sharedService.verifyAccountPin({
      identifier: this.accountIdentifier,
      isEmail: this.accountIdentifier.indexOf('@') > -1,
      pin: this.enteredPin
    }).then((res) => {
      console.log(res)
      if (res.success) {
        this.pin_text = 'Submit';
        this.isValidatingPin = false;
        this.isValidPin = true;
        this.onPinResponseCallback(true, res.token);
      } else {
        this.onPinResponseCallback(false, undefined);
        this.pin_text = 'Submit';
        this.isValidatingPin = false;
        this.isValidPin = false;
        this.callCenterFormControl.enable()
        this.callCenterFormControl.setErrors({invalid: true})
      }
    }).catch((err) => {
      this.pin_text = 'Submit';
      this.isValidatingPin = false;
      this.callCenterFormControl.enable();
      this.onPinResponseCallback(false, undefined);
      this.callCenterFormControl.setErrors({exception: true})
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/account-pin-validator/account-pin-validator.component.ts